// Web Audio API beep generator — no external assets required.
// Calls must originate from a user gesture (button click / camera open) so the
// audio context can resume on browsers that block autoplay.

let _ctx = null;

const getCtx = () => {
  try {
    if (!_ctx) {
      const Ctx = window.AudioContext || window.webkitAudioContext;
      if (!Ctx) return null;
      _ctx = new Ctx();
    }
    if (_ctx.state === 'suspended') {
      _ctx.resume().catch(() => {});
    }
    return _ctx;
  } catch (_) {
    return null;
  }
};

// Unlock the audio context as part of a user gesture (call from button click)
export const primeAudio = () => {
  const ctx = getCtx();
  if (!ctx) return;
  // Play a 1ms silent buffer to ensure iOS/Safari unlocks audio
  try {
    const buf = ctx.createBuffer(1, 1, 22050);
    const src = ctx.createBufferSource();
    src.buffer = buf;
    src.connect(ctx.destination);
    src.start(0);
  } catch (err) {
    // Audio unlock is best-effort — iOS/Safari may still block.
    console.debug('[scanSounds] primeAudio buffer failed:', err);
  }
};

const beep = (frequency, duration, type = 'sine', gainValue = 0.18, when = 0) => {
  const ctx = getCtx();
  if (!ctx) return;
  const t0 = ctx.currentTime + when;
  const osc = ctx.createOscillator();
  const gain = ctx.createGain();
  osc.type = type;
  osc.frequency.setValueAtTime(frequency, t0);
  // Soft attack + decay to avoid clicks
  gain.gain.setValueAtTime(0.0001, t0);
  gain.gain.exponentialRampToValueAtTime(gainValue, t0 + 0.01);
  gain.gain.exponentialRampToValueAtTime(0.0001, t0 + duration);
  osc.connect(gain).connect(ctx.destination);
  osc.start(t0);
  osc.stop(t0 + duration + 0.02);
};

// Success: two quick rising chirps (G5 → C6)
export const playScanSuccess = () => {
  beep(784, 0.12, 'sine', 0.2, 0);      // G5
  beep(1046, 0.18, 'sine', 0.22, 0.13); // C6
};

// Error: low buzz (one descending tone)
export const playScanError = () => {
  beep(220, 0.18, 'square', 0.16, 0);    // A3
  beep(180, 0.28, 'square', 0.16, 0.18); // F#3-ish
};
